<template>
  <div class="previewMim">
    <tree
      ref="componentTree"
      :params="queryParams"
      :xdata="xdata"
      @handleSelectedComponents="handleSelectedComponents"
      @list="getTreeList"
      @hideAll="handleHideAll"
      @showAll="handleShowAll"
      @showSingle="handleShowSingle"
      @hideSingle="handleHideSingle"
      @transparentAll="handleTransparentAll"
      @untransparentAll="handleUntransparentAll"
      @untransparentSingle="handleUntransparentSingle"
      @transparentSingle="handleTransparentSingle"
    ></tree>
    <div class="model" id="domId"></div>
    <Msg ref="msg" :msgValue="xdata"></Msg>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/url/api.js";
import Tree from "./tree.vue";
import Msg from "./msg.vue";

export default {
  data() {
    return {
      viewAdded: false,
      viewToken: null,
      viewer: null,
      queryParams: {},
      treeList: [],
      xdata: {},
    };
  },
  components: {
    Tree,
    Msg,
  },
  methods: {
    // 获取viewtoken
    get_view_token() {
      const url = api.get_bimface_view_token.url;
      var fileIds = {
        fileId: this.queryParams.bim_token,
      };
      axios.post(url, fileIds).then((resp) => {
        if (resp.data.status == "success") {
          this.viewToken = resp.data.info;
        } else {
          this.$message({
            type: "error",
            message: resp.data.msg,
          });
        }
      });
    },
    // 初始化显示组件
    get_bimface() {
      // 初始化显示组件
      var options = new BimfaceSDKLoaderConfig();
      options.viewToken = this.viewToken;
      if (this.$i18n.locale == "en") {
        options.language = BimfaceLanguageOption.en_GB;
      } else {
        options.language = BimfaceLanguageOption.zh_CN;
      }
      BimfaceSDKLoader.load(
        options,
        this.successCallback,
        this.failureCallback
      );
    },
    // 初始化组件成功回调
    successCallback(viewMetaData) {
      if (viewMetaData.viewType == "3DView") {
        // ======== 判断是否为3D模型 ========
        // 获取DOM元素
        var dom4Show = document.getElementById("domId");
        this.WebAppConfig =
          new Glodon.Bimface.Application.WebApplication3DConfig();
        this.WebAppConfig.domElement = dom4Show;
        // 创建WebApplication
        var app = new Glodon.Bimface.Application.WebApplication3D(
          this.WebAppConfig
        );
        // 添加待显示的模型
        app.addView(this.viewToken);
        // 从WebApplication获取viewer对象
        this.viewer = app.getViewer();
        // 监听添加view完成的事件
        this.viewer.addEventListener(
          Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded,
          () => {
            this.viewAdded = true;
            this.componentsClick();
            //自适应屏幕大小
            window.onresize = () => {
              this.viewer.resize(
                document.documentElement.clientWidth,
                document.documentElement.clientHeight - 40
              );
            };
          }
        );
      }
    },
    // 初始化组件失败回调
    failureCallback(error) {
      console.log(error);
    },
    // 获取列表项目
    getTreeList(data) {
      const { ProCategoryTree } = data;
      this.treeList = ProCategoryTree;
      this.xdata = data;
    },
    // 定位到构件
    handleSelectedComponents(obj) {
      const componentsObj = this.ProEntity[obj.ID];
      let ids = [];
      if (obj.children && obj.children.length) {
        ids = this.getBimfaceIdByXkey(obj);
      } else {
        ids = [componentsObj && componentsObj.xDataId].filter((item) => item);
      }
      if (!ids.length) {
        this.viewer.getModel().clearOverrideColorComponents();
        this.viewer.getModel().clearSelectedComponents();
        this.$refs.msg.handleOpen(null, null);
        return;
      }
      const parentNode = this.findItemById(this.treeList, obj.PID);
      this.$refs.msg.handleOpen(parentNode, componentsObj);
      let color = new Glodon.Web.Graphics.Color("#FF8C00", 0.8);
      this.viewer.getModel().clearOverrideColorComponents();
      this.viewer.getModel().clearSelectedComponents();
      this.viewer.getModel().overrideComponentsColorById(ids, color);
      this.viewer.getModel().setSelectedComponentsById(ids);
      this.viewer.getModel().zoomToSelectedComponents(0.5);
    },
    // 监听构件单击事件
    componentsClick() {
      this.viewer.addEventListener(
        Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked,
        this.getData
      );
    },
    // 移除构件单击事件
    removeComponentsClick() {
      this.viewer.removeEventListener(
        Glodon.Bimface.Viewer.Viewer3DEvent.MouseClicked,
        this.getData
      );
    },
    // 递归获取满足条件的子节点
    findItemById(list, ID) {
      // 每次进来使用find遍历一次
      let res = list.find((item) => item.ID == ID);
      if (res) {
        return res;
      } else {
        for (let i = 0; i < list.length; i++) {
          if (
            list[i].children instanceof Array &&
            list[i].children.length > 0
          ) {
            res = this.findItemById(list[i].children, ID);
            if (res) return res;
          }
        }
        return null;
      }
    },
    // 获取数据
    getData(data) {
      if (data.objectType === "Component" && data.elementId) {
        const ID = this.ProEntityKeys[data.objectId];
        if (!ID) {
          return;
        }
        const curobj = this.findItemById(this.treeList, ID);
        if (curobj) {
          this.handleSelectedComponents(curobj);
          this.$refs.componentTree.handleSelectNode(curobj);
        }
      }
    },
    // 判断模型是否加载完成
    isLoaded() {
      if (!this.viewAdded) {
        return;
      }
    },
    // 根据选中树形key对应出bimface构件ID
    getBimfaceIdByXkey(node) {
      this.isLoaded();
      const arr = [...node.descendantIds];
      return [
        ...arr.map((ID) => this.ProEntity[ID] && this.ProEntity[ID].xDataId),
      ].filter((item) => item);
    },
    // 隐藏所有构件
    handleHideAll() {
      this.isLoaded();
      this.viewer.getModel().hideAllComponents();
    },
    //显示所有构件
    handleShowAll() {
      this.isLoaded();
      this.viewer.getModel().showComponentsById(this.bimfaceKey);
    },
    // 显示单个构件
    handleShowSingle(node) {
      const bimfaceKeys = this.getBimfaceIdByXkey(node);
      this.viewer.getModel().showComponentsById(bimfaceKeys);
    },
    // 隐藏单个构件
    handleHideSingle(node) {
      const bimfaceKeys = this.getBimfaceIdByXkey(node);
      this.viewer.getModel().hideComponentsById(bimfaceKeys);
    },
    // 所有构件半透明
    handleTransparentAll() {
      this.viewer.getModel().transparentAllComponents();
    },
    // 取消所有构件半透明
    handleUntransparentAll() {
      this.viewer.getModel().opaqueAllComponents();
    },
    // 取消构件半透明
    handleUntransparentSingle(node) {
      const bimfaceKeys = this.getBimfaceIdByXkey(node);
      this.viewer.getModel().opaqueComponentsById(bimfaceKeys);
    },
    //构件半透明
    handleTransparentSingle(node) {
      const bimfaceKeys = this.getBimfaceIdByXkey(node);
      this.viewer.getModel().transparentComponentsById(bimfaceKeys);
    },
  },
  computed: {
    ProEntity: function () {
      return this.xdata && this.xdata.ProEntity;
    },
    bimfaceKey: function () {
      if (this.xdata) {
        const keys = Object.values(this.ProEntity).map((item) => item.xDataId);
        return keys;
      }
    },
    ProEntityKeys: function () {
      let obj = {};
      Object.keys(this.ProEntity).forEach((item) => {
        obj[this.ProEntity[item].xDataId] = item;
      });
      return obj;
    },
  },
  mounted() {
    this.queryParams = this.$route.query;
    this.get_view_token();
  },
  watch: {
    viewToken(newval) {
      this.get_bimface();
    },
  },
  beforeDestroy() {
    this.removeComponentsClick();
  },
};
</script>
<style>
.previewMim {
  overflow: hidden;
}
.previewMim,
.previewMim #domId {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mim/index.vue